<template>
  <component :is="themeComponent" v-if="themeComponent"></component>
</template>

<script>
import { markRaw } from 'vue'

export default {
  name: "navi-mobile",
  props: {
    theme: {
      type: String,
      default: 'hermeneus-base'
    }
  },
  data() {
    return {
      activeSubNavi: null,
      themeComponent: null
    }
  },
  watch: {
    theme: {
      immediate: true,
      async handler(newTheme) {
        const themePath = newTheme
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join('')
        try {
          const module = await import(`@modules/Themes/${themePath}/resources/vue/navi/NaviMobile${themePath}.vue`)
          this.themeComponent = markRaw(module.default)
        } catch (error) {
          console.error(`Failed to load theme component: ${error}`)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/**
* Ohne diese Eigenschaften verschwindet das mobile Menü beim Scrollen
 */
.navi-mobile {
  -webkit-transform: translateZ(0);
  bottom: 0;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-enter-from{
  opacity: 0;
  height: 0;
}
</style>